module.exports = __webpack_public_path__ + "img/2168.48849bd1.gif";